'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 * DOM Opearations
 */
function addClass(ele, className) {
    var classNameArray = className.split(' ');
    for (var i = 0; i < classNameArray.length; i++) {
        if (!hasClass(ele, classNameArray[i])) {
            ele.classList.add(classNameArray[i]);
        }
    }
}
function removeClass(ele, className) {
    var classNameArray = className.split(' ');
    for (var i = 0; i < classNameArray.length; i++) {
        if (hasClass(ele, classNameArray[i])) {
            ele.classList.remove(classNameArray[i]);
        }
    }
}
function hasClass(ele, className) {
    return ele.classList.contains(className);
}
function sumOffsetTop(ele) {
    var top = 0;
    while (ele) {
        top += ele.offsetTop;
        ele = ele.offsetParent;
    }
    return top;
}

exports.addClass = addClass;
exports.removeClass = removeClass;
exports.sumOffsetTop = sumOffsetTop;
